import { api } from '@/lib/api/client';
import type { PreferencesPatch } from '@/lib/api/types';

/** Remember a preference on the user (best effort; the local choice already applied). */
export function savePreference(patch: PreferencesPatch): void {
  void api.PATCH('/api/me/preferences', { body: patch }).catch(() => undefined);
}
